module.exports = __webpack_public_path__ + "img/voronoy-static-white.38b32bd.webp";